/**
 * Canonical public site origin — the single source of truth for the site's
 * base URL. ALWAYS build absolute URLs from this (or {@link absoluteUrl});
 * never hardcode a domain literal anywhere else in the codebase.
 *
 * The value comes from `NEXT_PUBLIC_SITE_URL`, which is inlined at build time
 * (the `NEXT_PUBLIC_` prefix), so this constant is safe to read from both
 * server and client components. In request handlers that have one, prefer the
 * incoming `Origin` header first and fall back to this — that keeps preview
 * deployments and custom domains self-referential.
 *
 * `NEXT_PUBLIC_SITE_URL` should always be set in every environment (it is a
 * launch/deploy requirement). The `https://www.theduchy.com` fallback below is
 * only a safety net for a misconfigured env — it points at the live production
 * domain so an unset var can never silently ship the retired `new.theduchy.com`
 * host to real users (the cutover footgun). Since `NEXT_PUBLIC_` is baked in at
 * build time, changing the env requires a fresh build/redeploy, not a promote.
 */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL || 'https://www.theduchy.com'
).replace(/\/$/, '')

/**
 * Join a path onto {@link SITE_URL}. Absolute URLs pass through unchanged.
 */
export function absoluteUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path
  return `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`
}
